module.exports = __webpack_public_path__ + "static/img/7-en.e2a8f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/7-en.png
// module id = ktGZ
// module chunks = 1